import { useQuery } from "convex/react";
import { api } from "@convex/_generated/api";
import { isAdminRole } from "@shared/auth/roles";

export function useAccountContext() {
  const current = useQuery(api.companies.queries.getCurrentUserWithCompany);
  return {
    isAdmin: isAdminRole(current?.user.role),
    company: current?.company ?? null,
  };
}
